<div [class.opacity-50]="false" [style.pointer-events]="true ? 'auto' : 'none'">
    <div class="form-segment mt-20">
        <div class="segment-title my-15 g-just-flex gap-12 align-items-center">
            <mat-icon>medical_services</mat-icon>
            <span>Care Plan</span>
        </div>

        <mat-card>
            <mat-card-header>
                <mat-card-title>Care Plan Form</mat-card-title>
                @if (dialogRef) {
                <button mat-icon-button (click)="closeDialog()" class="close-button" style="flex: 1 1 auto; 
                    display: flex; justify-content: flex-end; position: sticky; top: 0;">
                    <mat-icon>close</mat-icon>
                </button>
                }
            </mat-card-header>

            <mat-card-content>
                @if (carePlanFormFields?.carePlan && !carePlanId) {
                <app-dynamic-forms-v2 [formFields]="carePlanFormFields['carePlan'].formFields"
                    (formSubmitted)="onCarePlanSubmitted($event)"
                    [formMetaData]="carePlanFormFields['carePlan'].formMetadata" #carePlanForm>
                </app-dynamic-forms-v2>
                }

                @if (admissionSubmitted && carePlanId) {
                <div class="tasks-section mt-20">
                    <div class="g-just-flex justify-content-between align-items-center mb-15">
                        <div class="g-just-flex gap-12 align-items-center">
                            <mat-icon>task</mat-icon>
                            <span class="section-title">Tasks</span>
                            @if (carePlanId) {
                            <span class="small-subtitle subtitle-text-color-2">(CarePlan: {{ carePlanId }})</span>
                            }
                        </div>
                        <button mat-raised-button color="primary" (click)="toggleTaskForm()">
                            <mat-icon>{{ displayTaskForm ? 'expand_less' : 'expand_more' }}</mat-icon>
                            {{ displayTaskForm ? 'Hide Tasks' : 'Add/View Tasks' }}
                        </button>
                    </div>

                    @if (displayTaskForm) {
                    <app-testing-tasks [carePlanId]="carePlanId"></app-testing-tasks>
                    }
                </div>
                } @else if (admissionSubmitted && !carePlanId) {
                <div class="info-message mt-20 p-15" style="
                    background: var(--mat-sys-primary-container);
                    border-radius: 8px;
                    color: var(--mat-sys-on-primary-container);
                ">
                    <div class="g-just-flex gap-12 align-items-center">
                        <mat-icon>info</mat-icon>
                        <span>Please submit the care plan form above to enable task creation.</span>
                    </div>
                </div>
                }
            </mat-card-content>
        </mat-card>
    </div>
</div>